<template>
	<v-dialog
		v-model="visible_local"
		:max-width="!$vuetify.breakpoint.smAndDown ? 'calc(100vw - 200px)': 'calc(100vw)'"
	>
		<v-data-table
			:headers="header_local"
			:items="filterResults"
			:loading="loading"
			:height="filterResults.length > 4 ? 280:'auto'"
			:items-per-page="-1"
			:hide-default-header="!$vuetify.breakpoint.smAndDown"
			hide-default-footer
			disable-sort
		>
			<template v-slot:top>
				<div class="table-head">Select expenses to add</div>
			</template>
			<template v-slot:progress>
				<v-progress-linear :color="color" indeterminate></v-progress-linear>
			</template>
			<template v-if="!$vuetify.breakpoint.smAndDown" v-slot:header="{ props: { headers } }">
				<thead>
					<tr>
						<th 
							v-for="item in headers" 
							:key="item.value" 
							class="header-th" 
							@mouseover="isHover = item.value"
							@mouseout="isHover = ''">
							<div :class="`header-item`" v-if="item.showable">
								<div v-if="item.type === 'option'">
									<v-checkbox
										color="info"
										:value="allSelect"
										:indeterminate="indeterminate"
										:disabled="filterResults.length === 0"
										@change="onSelectAllChange($event)"
									></v-checkbox>
								</div>
								<div class="header-item-sub">
									<div class="header-item-text">{{ item.text }}</div>
									<SortUpDown 
										v-if="item.type === 'sort'" 
										class="icon icon-sort-up-down" 
										:selected="isHover === item.value" 
										:selected_color="color" 
										@click="onSort(item.value)"/>
								</div>
								<v-menu offset-y nudge-left="200" >
									<template v-slot:activator="{ on, attrs }">
										<div class="icon-wrap" v-bind="attrs" v-on="on">
											<ShowSearch 
												class="icon" 
												v-if="item.searchable" 
												:selected="isHover === item.value"
												:selected_color="color"/>
										</div>
									</template>
									<div class="search-box">
										<v-text-field
											placeholder="Search Title..."
											outlined
											dense
											hide-details="auto"
											color="#00AAFD" 
											:value="current_key === item.value ? searchValue : ''"
											@input="searchValue = $event"
											@click.stop
										/>
										<div class="search-box-button">
											<div @click.stop="onClean">CLEAR</div>
											<div @click="onSearch(item.value)">SEARCH</div>
										</div>
									</div>
								</v-menu>
								<v-menu offset-y nudge-left="80" min-width="100px" :close-on-content-click="false">
									<template v-slot:activator="{ on, attrs }">
										<div class="icon-wrap" v-bind="attrs" v-on="on">
											<FirstList v-if="item.value === 'currency'" class="icon icon-sort-up-down" 
												:selected="isHover === item.value"
												:selected_color="color"/>
										</div>
									</template>
									<div v-for="currency in currencies" :key="currency.id">
										<v-checkbox
											class="filter-box mt-0"
											v-model="select_currency"
											:label="currency.symbol"
											:value="currency.id"
											color="info"
											dense
											hide-details>
										</v-checkbox>
									</div>
								</v-menu>
							</div>
						</th>
					</tr> 
				</thead>
			</template>
			<template v-slot:[`item.select`]="{ item }">		
				<v-checkbox
					v-model="item.select"
					color="info"
				></v-checkbox>	
			</template>
			<template v-slot:[`item.date`]="{ item }">			
				<div>{{ formatDate(item.date) }}</div>
			</template>
			<template v-slot:[`item.currency`]="{ item }">			
				<span v-html="item.currency.symbol" ></span>
			</template>
			<template v-slot:[`item.value`]="{ item }">	
				<span>{{ formatNumber(item.value) }}</span>		
			</template>
			<template v-slot:[`item.tax_amount`]="{ item }">	
				<span>{{ formatNumber(item.tax_amount) }}</span>		
			</template>
			<template v-slot:[`item.amount`]="{ item }">	
				<span>{{ formatNumber(item.amount) }}</span>		
			</template>
			<template v-slot:[`item.markup_perc`]="{ item }">	
				<span>{{ formatNumber(item.markup_perc) }}</span>		
			</template>
			<template v-slot:[`item.markup_value`]="{ item }">	
				<span>{{ formatNumber(item.markup_value) }}</span>		
			</template>
			<template v-slot:[`item.code`]="{ item }">		
				<div v-html="item.code && item.code.code" ></div>
			</template>
			<template v-slot:[`item.title`]="{ item }">	
				<div v-html="item.title && item.title.display_name" ></div>
			</template>
			<template v-slot:[`item.phase`]="{ item }">	
				<div v-html="item.phase && item.phase.display_name" ></div>
			</template>
			<template v-slot:[`item.kind`]="{ item }">	
				<div v-html="item.kind && item.kind.display_name" ></div>
			</template>
			<template v-slot:[`item.thumbnail`]="{ item }">
				<File 
					v-if="image_type.includes(item.image_type)"
					width="24" 
					hight="24" 
					:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'" />
				<PDF
					v-if="item.image_type === pdf_type" 
					width="24" 
					hight="24"
					:color="item.is_used ? '#DADADA' : 'rgba(25, 42, 62, 0.8)'" />	
			</template>
			<template v-slot:[`item.is_used`]="{ item }">
				<span v-if="item.is_used === false">Not added to claim</span>		
			</template>
			<template v-slot:footer>
				<div class="add-receipts-btn">
					<div class="mr-3 btn-close-able" @click="onCancel()">Cancel</div>
					<div :class="btnStatus ? 'btn-add-able' : 'btn-add-disable'" @click="onAddReceipts()">Add Selected Expenses</div>
				</div>
			</template>
		</v-data-table>
	</v-dialog>
</template>
<script>
import SortUpDown from '@/components/icons/sort_up_down';
import ShowSearch from '@/components/icons/show_search';
import FirstList from "@/components/icons/first_list";
import File from '@/components/icons/attached_file_image';
import PDF from '@/components/icons/attached_file_pdf';

import Receipt from "@/models/receipt";
import moment from 'moment';
import config from "@/config.js";

const FONT_COLOR = '#00AAFD';
const IMAGE_TYPE = ['image/jpeg','image/png'];
const PDF_TYPE = 'application/pdf';

export default {
	name: 'AddReceiptsDialog',
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => [],
		},
		visible: {
			type: Boolean,
			default: false,
		},
		exist: {
			type: Array,
			default: () => [],
		}
	},
	components: {
		SortUpDown,
		ShowSearch,
		FirstList,
		File,
		PDF
	},
	data() {
		return {
			loading: false,
			error_msg: '',
			visible_local: this.visible,
			header_local: config.receipts_head.filter(head => {return head.showable}),
			receipts_original: [],
			receipts: [],
			select_currency: this.currencies.map(currency => { return currency.id }),
			searchValue: '',
			sortByAscent: false,
			isHover: '',
			current_key: '',
			image_type: IMAGE_TYPE,
			pdf_type: PDF_TYPE
		}
	},
	created() {
		this.load_receipts();
	},
	watch: {
		user_abid() {
			if (this.user_abid !== 0) {
				this.load_receipts();
			}
		},
		select_currency() {
			this.receipts = this.receipts_original.filter(receipt => {
				return this.select_currency.includes(receipt.currency.id);
			});
		},
		error_msg() {
			if (this.error_msg.length !== 0) {
				this.$emit('error', this.error_msg);
			}
		},
		visible_local() {
			if (!this.visible_local) {
				this.$emit('visible');
			}
		}
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		filterResults() {
			const filterRes = [];
			this.receipts.forEach(res => {
				const obj = {};		
				obj['id']	= res.id;

				this.header_local.forEach(item => {
					if (item.showable) {
						let tmp = null;
						
						if (item.value === 'symbol') {
							tmp = res.currency.symbol;
						} else if(item.value === 'code') {
							tmp = res.job;
						} else if(item.value === 'title') {
							tmp = res.job;
						} else if(item.value === 'value') {
							tmp = Number(res.value.toFixed(2));
						} else if(item.value === 'tax_amount') {
							tmp = Number(res.tax_amount);
						} else if(item.value === 'amount') {
							const amount = Number(res.value);
							const amount_tax = Number(res.tax_amount);
							tmp = Number(Number(amount + amount_tax).toFixed(2));
						} else if(item.value === 'markup_perc') {
							tmp = Number(Number(res.markup_perc).toFixed(2));
						} else if(item.value === 'markup_value') {
							tmp = Number(res.markup_value)
						} else {
							tmp = res[item.value];
						}

						obj[item.value] = tmp;

						obj['image_type'] = res.image_type
					}
				});

				filterRes.push(obj);
			});
			return filterRes;
		},
		indeterminate() {
			return this.filterResults.length !== 0 
				&& !this.filterResults.every(res => {return res.select === true})
				&& this.filterResults.some(res => { return res.select === true});
		},
		btnStatus() {
			return this.filterResults.length !== 0 
				&& this.filterResults.some(res => { return res.select === true});
		},
		allSelect() {
			return this.filterResults.length !== 0 
				&& this.filterResults.every(res => { return res.select === true});
		}
	},
	methods: {
		load_receipts() {
			const user_abid = this.user_abid;

			this.loading = true;

			if (user_abid != 0) {
				const receipt = new Receipt();
				receipt.list(user_abid)
					.then(data => {
						this.loading = false;

						const data_tmp = data.filter(data => {
							return !data.is_used && !this.exist.includes(data.id);
						});
						data_tmp.sort((a, b) => { return a.id - b.id});

						this.receipts_original = data_tmp;
						this.receipts = data_tmp;
					})
					.catch(e => {
						this.loading = false;
						this.error_msg = e;
					});
			}
		},
		onCancel() {
			if (this.visible_local) {
				this.$emit('visible');
			}
		},
		onAddReceipts() {
			if (this.btnStatus) {
				const arr_tmp = [];
				this.filterResults.forEach(res => {
					if (res.select) {
						arr_tmp.push(res.id);
					}
				});
				const res_arr = this.receipts_original
					.filter(res => arr_tmp.includes(res.id))
					.map(res => ({
						...res,
						amount: Number(res.value) + Number(res.tax_amount),
					}));

				this.$emit('add-receipts', res_arr);
			}
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		formatNumber(value) {
			// from nmber to string, 12345.00 -> 12,345.00
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(Number(value) || 0);
		},
		onSelectAllChange(value) {
			if (!this.loading && value) {
				this.filterResults.forEach(receipt => {
					if (!receipt.is_used) {
						receipt.select = true;
					}
				});
			} else if(!this.loading) {
				this.filterResults.forEach(receipt => {
					receipt.select = false;
				});
			}
		},
		onSort(key) {
			this.sortByAscent = !this.sortByAscent;

			if (key === 'value') {
				this.sortByAscent
					? this._sort_ascent_number(this.receipts, key)
					: this._sort_descent_number(this.receipts, key);
			} else {
				this.sortByAscent
					? this._sort_ascent(this.receipts, key)
					: this._sort_descent(this.receipts, key);
			}	
		},
		onClean() {
			this.searchValue = '';
			this.receipts = this.receipts_original;
		},
		onSearch(key) {
			if (this.searchValue.length !== 0) {
				this.current_key = key;
				const arr_filter = this._filterKey(this.receipts_original, key, this.searchValue);
				const arr_replace = JSON.parse(JSON.stringify(arr_filter));

				// to hightlight the kewwords
				const regex = new RegExp(this.searchValue, 'gi');
				arr_replace.forEach(arr => {
					if (key === 'code') {
						if (arr['job']) {
							arr['job'].code = arr['job'].code.replace(regex, (keyword) => {
								return `<font color="${FONT_COLOR}">${keyword}</font>`;
							});
						} 
					} else if(key === 'title') {
						if (arr['job']) {
							arr['job'].display_name = arr['job'].display_name.replace(regex, (keyword) => {
								return `<font color="${FONT_COLOR}">${keyword}</font>`;
							});
						} 
					} else {
						if (arr[key]) {
							if ( typeof(arr[key]) === 'object' ) {
								arr[key].display_name = arr[key].display_name.replace(regex, (keyword) => {
									return `<font color="${FONT_COLOR}">${keyword}</font>`;
								});
							} else {
								arr[key] = arr[key].replace(regex, (keyword) => {
									return `<font color="${FONT_COLOR}">${keyword}</font>`;
								});
							}
						}
					}
				});
				this.receipts = arr_replace;
			} 
		},
		_sort_ascent(arr, key) {
			if (key === 'code') {
				key = 'job';
			}

			if (key === 'title') {
				key = 'job';
			}

			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';
				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				}

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA < valueB) {
					return -1;
				}
				if (valueA > valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_descent(arr, key) {
			if (key === 'code') {
				key = 'job';
			}

			if (key === 'title') {
				key = 'job';
			}

			arr.sort((a, b) => {
				let valueA = '';
				let valueB = '';

				if (a[key]) {
					valueA = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
				} 

				if (b[key]) {
					valueB = typeof(b[key]) === 'object' ? b[key].display_name.toUpperCase() : b[key].toUpperCase();
				}

				if (valueA > valueB) {
					return -1;
				}
				if (valueA < valueB) {
					return 1;
				}

				return 0;
			});
		},
		_sort_ascent_number(arr, key) {
			arr.sort((a, b) => {
				return a[key] - b[key];
			});
		},
		_sort_descent_number(arr, key) {
			arr.sort((a, b) => {
				return b[key] - a[key];
			});
		},
		_filterKey(arr, key, filter) {	
			let fliter_Arr = [];
			const filter_UpperCase = filter.toUpperCase();
			fliter_Arr = arr.filter(a => {
				let A = '';
				if (key === 'code') {
					if (a['job']) {
						A = a['job'].code.toUpperCase();
					} 
				} else if(key === 'title') {
					if (a['job']) {
						A = a['job'].display_name.toUpperCase();
					} 
				} else {
					if (a[key]) {
						A = typeof(a[key]) === 'object' ? a[key].display_name.toUpperCase() : a[key].toUpperCase();
					} 
				}
				
				return A.includes(filter_UpperCase);
			});
			
			return fliter_Arr;
		},
	}
}
</script>
<style lang="scss" scoped>
.table-head {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	height: 65px;
	padding: 0 20px;
	background: #FAFAFA;
	color: #192A3E;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 32px;
	border-bottom: 1px solid #C9C9C9;
	border-radius: 4px 4px 0 0;
	span {
		font-weight: bold;
	}
}
.header-th {
	background: #FAFAFA;
	&:hover {
		background: #EAEAEA;
	}
}
.header-item {
	display: flex;
  flex-flow: row nowrap;
	justify-content: space-between;
  align-items: center;
}
.header-th:hover .icon {
	visibility: visible; 
}
.header-item-sub {
	display: flex;
  flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
}
.icon-wrap {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
.icon {
	visibility: hidden;
	width: 14px;
  height: 14px;
	&:hover {
		cursor: pointer;
	}
}
.icon-sort-up-down {
  margin-left: 6px;
}
.search-box {
	padding: 13px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background: #FFFFFF;
	border-radius: 4px;
	.search-box-button {
		margin-top: 9px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		div {
			display: flex;
			flex-flow: row nowrap;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			padding: 0 21px;

			font-family: Roboto;
			font-style: normal;
			font-weight: 500;
			font-size: 14px;
			height: 36px;

			&:hover {
				cursor: pointer;
			}
		}
		:first-child {
			border: 1px solid rgba(25, 42, 62, 0.7);
			margin-right: 10px;
			color: rgba(25, 42, 62, 0.7);
		}
		:last-child {
			border: 1px solid #00AAFD;
			background: #00AAFD;
			color: #FFFFFF;
		}
	}
}
.filter-box {
	background: #FFFFFF;
}
.add-receipts-btn {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0 16px;
	height: 70px;
	background: #FAFAFA;
	div {
		padding: 0 24px;
		height: 36px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 36px;
		
	}
}
.btn-close-able {
	color: rgba(25, 42, 62, 0.7);
	border: 1px solid rgba(25, 42, 62, 0.7);
	border-radius: 4px;
	&:hover {
		cursor: pointer;
	}
}
.btn-close-disable {
	color: rgba(25, 42, 62, 0.4);
	border: 1px solid rgba(25, 42, 62, 0.4);
	border-radius: 4px;
}

.btn-add-able {
	color: #FFFFFF;
	background: #00AAFD;
	border-radius: 4px;
	&:hover {
		cursor: pointer;
	}
}
.btn-add-disable {
	color: rgba(25, 42, 62, 0.4);
	border: 1px solid rgba(25, 42, 62, 0.4);
	border-radius: 4px;
}
</style>
